import Vue from "vue";
import Vuex from "vuex";
import { getMenuList, getUserRoles } from "network/mainApi";
import { buttonList } from "@/utils/button";
import router from "@/router"

Vue.use(Vuex);

export default new Vuex.Store({
	/**
	 * 存放的基本的数据，用于对数据进行初始化，
	 */
	state: {
		isLogin: false, //是否登录
		roleMenuList: [], //用户菜单列表
		opened: false, //菜单栏是否折叠
		state: "",
		role: [],
		buttons: JSON.parse(localStorage.getItem("buttons")) || [],
		userId: localStorage.getItem("userId") || "",
	},
	/**
	 * 同步函数,对数据(state)的变更只能在mutations里进行,通过this.$store.commit触发mutations的方法
	 */
	mutations: {
		setIsLogin: (state, isLogin) => {
			state.isLogin = isLogin;
		},
		setRoleMenuList: (state, roleMenuList) => {
			state.roleMenuList = roleMenuList;
			// router.addRoutes(accessRoutes)
			// Location.reload()

		},
		// 修改是否折叠
		isOpened(state, info) {
			state.opened = info;
		},
		// 存状态
		setState(state, info) {
			state.state = info;
		},
		setRole(state, { roles, userId }) {
			state.buttons = buttonList[roles[0]];
			state.userId = userId;
			localStorage.setItem("buttons", JSON.stringify(state.buttons));
			localStorage.setItem("userId", userId);
			localStorage.setItem("roles", roles);
		},
	},
	/**
	 * 类似于计算属性，用于监听state的值是否变化，会缓存数据
	 */
	getter: {
		getIsLogin: (state) => state.isLogin,
	},
	/**
	 * 异步函数，通过this.$store.dispatch触发actions中的方法， 然后再调用mutation中的方法去修改state中的值,
	 */
	actions: {
		getMenuList({ commit }) {
			getMenuList().then((e) => {
				let { code, data, msg } = e.data;
				if (code == 200) {
					commit("setRoleMenuList", data);
				}
			});
		},
		getUserRoles({ commit }) {
			getUserRoles().then((e) => {
				let { code, data, msg } = e.data;
				if (code == 200) {
					commit("setRole", data); //data.roles
					// 1 管理员  9 运维  10 信源  11app普通角色
				}
			});
		},
	},
	/**
	 * 模块化（将store分割成不同的模块）
	 */
	modules: {},
});
